// frontend/src/pages/asset-admin/TransferActionsCell.js
/**
 * Actions for Transfer History table / cards: View, Letter, Cancel.
 * Tables keep View (showView=true). Tappable cards pass showView=false so the
 * card itself is the open affordance — footer only for Letter/Cancel.
 */

import React from 'react';
import { Eye, FileText, X } from 'lucide-react';

export function getCancellable(transfer, currentUserStaffId, isAssetCustodian) {
  if (!transfer) return false;
  const status = transfer.status;
  if (status !== 'pending_acceptance' && status !== 'pending_receipt') return false;
  if (transfer.is_expired) return false;
  if (isAssetCustodian) return true;
  if (status === 'pending_acceptance') {
    return currentUserStaffId && transfer.from_employee_staff_id === currentUserStaffId;
  }
  if (status === 'pending_receipt') {
    const sid = currentUserStaffId;
    if (!sid) return false;
    return (
      transfer.from_employee_staff_id === sid ||
      transfer.created_by_staff_id === sid
    );
  }
  return false;
}

/** Non-View actions that warrant a card footer strip. */
export function hasTransferSecondaryActions(transfer, currentUserStaffId, isAssetCustodian, onViewLetter) {
  const showCancel = getCancellable(transfer, currentUserStaffId, isAssetCustodian);
  const showLetter = !!transfer?.ack_letter_id && typeof onViewLetter === 'function';
  return showCancel || showLetter;
}

const TransferActionsCell = ({
  transfer,
  currentUserStaffId,
  isAssetCustodian,
  onView,
  onViewLetter,
  onCancelClick,
  isCancelling,
  showView = true,
}) => {
  const showCancel = getCancellable(transfer, currentUserStaffId, isAssetCustodian);
  const showLetter = !!transfer?.ack_letter_id && typeof onViewLetter === 'function';

  if (!showView && !showLetter && !showCancel) return null;

  return (
    <div className="flex items-center justify-end gap-1">
      {showView && (
        <button
          type="button"
          onClick={() => onView?.(transfer)}
          className="icon-button-admin"
          title="View details"
          aria-label="View details"
        >
          <Eye className="w-5 h-5" />
        </button>
      )}
      {showLetter && (
        <button
          type="button"
          onClick={() => onViewLetter(transfer)}
          className="icon-button-admin"
          title={`View acknowledgement letter${transfer.ack_letter_reference ? ` (${transfer.ack_letter_reference})` : ''}`}
          aria-label={`View acknowledgement letter${transfer.ack_letter_reference ? ` ${transfer.ack_letter_reference}` : ''}`}
        >
          <FileText className="w-5 h-5" />
        </button>
      )}
      {showCancel && (
        <button
          type="button"
          onClick={() => onCancelClick?.(transfer)}
          disabled={isCancelling}
          className="icon-button-danger disabled:opacity-50 disabled:cursor-not-allowed"
          title="Cancel assignment"
          aria-label="Cancel assignment"
        >
          <X className="w-5 h-5" />
        </button>
      )}
    </div>
  );
};

export default TransferActionsCell;
